export default __webpack_public_path__ + "static/media/powered-by-white.3a6425e2.png";